import { Observable } from 'rxjs'
import { LatLng } from 'leaflet'

export abstract class GeoLocationService {
  /***
   * Returns the users location
   */
  public abstract getLocation(): Observable<LatLng>
}
